export default __webpack_public_path__ + "static/media/Tanya_tmb.95fd72a8.jpg";